module.exports = __webpack_public_path__ + "static/img/1156_phase_function_Paper_Points.36f2ee7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1156_phase_function_Paper_Points.png
// module id = cv3t
// module chunks = 0